import Sticky from 'sticky-js';

export const addSticky = (selector) => new Sticky(selector);
